import React, { useMemo, useState } from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import ProductTable from './ProductTable';
import DetailsTab from './submenu/DetailsTab/DetailsTab';
import Submenu from './submenu/Submenu';
import {
  useGetListOfValuesQuery
} from 'common/api/MasterdataApiSlice';
import { PRODUCT_LOV_TYPES } from '../types/LOVTypes';

const Products = () => {

  const [isDetailsTab, setIsDetailsTab] = useState(true);

  const { data: listOfValuesData } = useGetListOfValuesQuery({});

  // Categorize items using correct type values from LOVTypes
  const categorizedLOVData = useMemo(() => {
    if (!listOfValuesData?.data) return {};
    
    const categories: { [key: string]: any[] } = {};
    
    // Initialize categories
    Object.values(PRODUCT_LOV_TYPES).forEach(type => {
      categories[type] = [];
    });
    
    // Categorize items based on their type
    listOfValuesData.data.forEach(item => {
      if (categories[item.type]) {
        categories[item.type].push(item);
      }
    });
    
    return categories;
  }, [listOfValuesData]);

  // Extract specific category arrays using correct type values
  const productLineColour = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_LINE_COLOUR] || [];
  const productStatus = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_STATUS] || [];
  const productCategory = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_CATEGORY] || []; // PROD_LN_CAT
  const productSubCategory = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_SUB_CATEGORY] || []; // PROD_LN_CAT_SUB
  const productSize = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_SIZE] || [];
  const productBrand = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_BRAND] || [];
  const productType = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_TYPE] || [];
  const productSubType = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_SUB_TYPE] || []; // PRODUCT_TYPE_SUB
  const productUom = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_UOM] || [];
  const productMarginType = categorizedLOVData[PRODUCT_LOV_TYPES.PRODUCT_MARGIN_TYPE] || [];

  return (
    <React.Fragment>
      <div className="page-content p-0">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card className="card-table-container">
                <CardBody>
                  {isDetailsTab ? <ProductTable /> : <DetailsTab />}
                </CardBody>
              </Card>
              <Submenu setIsDetailsTab={setIsDetailsTab} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Products;
